import { useState } from 'react'
import PropTypes from 'prop-types'

import TableView, { invoicePropType } from './View'
import NoResults from './NoResults'

import useDownloadFile from './useDownloadFile'

const HEAD_CELLS = [
  {
    id: 'shippingDate',
    sortable: false,
  },
  {
    id: 'invoice-number',
    sortable: false,
  },
  {
    id: 'clientCenterCode',
    sortable: false,
  },
  {
    id: 'amount-in-€',
    sortable: false,
  },
]

const TablePropTypes = {
  invoices: PropTypes.arrayOf(invoicePropType),
}

const Table = ({ invoices }) => {
  const [, setSelectedInvoices] = useState([])

  const downloadFile = useDownloadFile()

  const handleDownloadFile = (invoiceId, fileType) => {
    downloadFile(invoiceId, fileType)
      .then(() => {})
      .catch(error => {
        // TODO: controlar el error y mostrar feedback al usuario.
        console.log('error downloading file', error)
      })
  }

  if (invoices.length === 0) {
    return <NoResults />
  }

  return (
    <TableView
      invoices={invoices}
      tableHeadsCells={HEAD_CELLS}
      selectInvoices={setSelectedInvoices}
      downloadFile={handleDownloadFile}
    />
  )
}

Table.propTypes = TablePropTypes

export default Table
